module.exports = __webpack_public_path__ + "static/img/10031.f9cfe962.png";